import React, { useContext, useEffect, useState } from "react";
import mediaImage from '../../src/assets/images/media-image.png'
import profileImage from '../../src/assets/images/media-image-2.png'
import like from '../../src/assets/images/like.png'
import like_click from '../../src/assets/images/shadowz_icon/like_click.svg'
import tags_click from '../../src/assets/images/shadowz_icon/tags_click.svg'
import comment_click from '../../src/assets/images/shadowz_icon/comment_click.svg'
import coin_click from '../../src/assets/images/shadowz_icon/coin_click.svg'
import comment from '../../src/assets/images/comment.png'
import tag from '../../src/assets/images/tag.png'
import dollar from '../../src/assets/images/dollar.png'
import like2 from '../../src/assets/images/like-2.svg'
import comment2 from '../../src/assets/images/comment-2.svg'
import tag2 from '../../src/assets/images/user-2.svg'
import dollar2 from '../../src/assets/images/dollar-2.svg'
import { getUserProfileImage } from "../utils/constant_value";
import dollarlogo from '../../src/assets/images/dollar-logo.png'
import nodata from '../../src/assets/images/no_data2.svg'
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import placeholder from "../assets/images/profile_placeholder.png";
import smallPlaceholder from "../assets/images/profile_small_placeholder.png"
import henceforthApi from "../utils/henceforthApi";
import { Carousel } from "react-bootstrap";
import moment from "moment";
import Lightbox from "react-image-lightbox";
import Swal from "sweetalert2";
import eye_light from '../../src/assets/images/eye_light.svg'
import eye_dark from '../../src/assets/images/eye_dark.svg'
import Spinner from "../components/spinnerRound";
import { GlobalContext } from "../context/Provider";
import { MessageSquareText, Tag, ThumbsUp } from "lucide-react";
import VideoPlayer from "../components/hslVideoPlayer";
const MediaDetails = () => {
    const match = useMatch("media/:id/:type")
    const navigate = useNavigate()
    const location = useLocation()
    const [photoIndex, setPhotoIndex] = useState(0)
    const [isOpen, setIsOpen] = useState(false)
    const [lightboxImages, setLightboxImages] = useState([])
    const [loading, setLoading] = useState(false)
    const [state, setState] = useState()
    const [getTags, setGetTags] = useState([]);
    const [getLike, setGetLike] = useState([]);
    const [getComment, setGetComment] = useState([]);
    const [getView, setGetView] = useState([]);
    const [manageMedias, setManageMedias] = useState({
        type: "",
        _id: "",
        admin_verified: false,
        language: "ENGLISH",
        account_status: "",
    });
    const { handleError } = useContext(GlobalContext);
    const profile_pic = state?.user_data?.profile_pic
    const social_type = state?.user_data?.social_type

    // const handleView = async (_id) => {
    //     //   setViews(true);
    //     const viewResponse = await henceforthApi.Stories.view(_id);
    //     setGetView(viewResponse);
    // };
    const getDetails = async () => {
        let apiRes = await henceforthApi.Media.details(match?.params?.id)
        setState(apiRes)
        console.log(apiRes, "media");
    }
    const handleNavigate = (type) => {
        navigate(`/media/${match.params.id}/${type}`)
    }
    const handleActivity = async () => {
        try {
            const activityType = match.params.type
            console.log(activityType, match.params.id, activityType == "like", "activityType")
            console.log(state.data.post_type, "post_type")
            
            // Only proceed if state.data is available
            if (!state?.data) {
                console.log("Waiting for state.data to be loaded...");
                return;
            }
            
            if (activityType == "like") {
                setLoading(true)
                const likeResponse = await henceforthApi.Posts.like(match.params.id);
                console.log(likeResponse, "likeResponse");
                activityType == "like" ? setGetLike(likeResponse) : setGetComment(likeResponse);
                setLoading(false)
                setReadMore(10)
            } else if (activityType == "comment" && state?.data?.post_type == "POST") {
                setLoading(true)
                const commentResponse = await henceforthApi.Posts.Comment(match.params.id);
                console.log(commentResponse, "commentResponse");
                setGetComment(commentResponse);
                setLoading(false)
                setReadMore(10)
            }else if (activityType == "comment" && state?.data?.post_type == "STORY") {
                setLoading(true)
                const commentResponse = await henceforthApi.Stories.reply(match.params.id);
                console.log(commentResponse, "commentResponse");
                setGetComment(commentResponse);
                setLoading(false)
                setReadMore(10)
            }
            else if (activityType == "tags") {
                setLoading(true)
                const TagsResponse = await henceforthApi.Posts.tags(match.params.id);
                setGetTags(TagsResponse);
                setLoading(false)
                setReadMore(10)
            }
            else if (activityType == "coins") {
                setLoading(true)
                const CoinsResponse = await henceforthApi.Posts.coins(match.params.id);
                setGetCoins(CoinsResponse);
                setLoading(false)
                setReadMore(10)
            }
            else if (activityType == "view") {
                setLoading(true)
                const viewResponse = await henceforthApi.Stories.view(match.params.id);
                setGetView(viewResponse);
                setReadMore(10)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }
    const handleActivate = async () => {
        let data = {
            post_id: match.params.id,
            language: "ENGLISH",
            type: state.data.post_status == "Active" ? `DEACTIVE` : `ACTIVE`,
        };
        try {
            const manage_users = await henceforthApi.Common.activateDeactivate(data);
            console.log("Manage users", manage_users);
            setManageMedias(data);
            {
                state.data.post_status == "Active"
                    ? Swal.fire({
                        title: "Deactivated",
                        text: `${state.data.post_type == "POST" ? "Post" : state.data.post_type == "STORY" ? "Story" : "Reel"} Deactivated Successfully`,
                        icon: "success",
                        confirmButtonText: "OK",
                        confirmButtonColor: "black"
                    })
                    : Swal.fire({
                        title: "Activated",
                        text: `${state.data.post_type == "POST" ? "Post" : state.data.post_type == "STORY" ? "Story" : "Reel"} Activated Successfully`,
                        icon: "success",
                        confirmButtonText: "OK",
                        confirmButtonColor: "black"
                    });
            }
        } catch (error) {
            handleError(error)
        }
    }
    const [readMore, setReadMore] = useState(10)
    const [getCoins, setGetCoins] = useState([]);

    const initialiseLightBox = (data) => {
        data.map((item, index) => setPhotoIndex(index))
        // setPhotoIndex(0)
        setIsOpen(true)
        setLightboxImages(data)
    }
    
    useEffect(() => {
        getDetails()
    }, [manageMedias])
    useEffect(() => {
        // Call handleActivity only after state.data is populated
        if (state?.data) {
            handleActivity()
        }
    }, [match.params.type, match.params.id, state?.data])
    return (
        <>
            <section>
                <div className="main-box">
                    <div>
                        {isOpen && <Lightbox
                            mainSrc={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${lightboxImages[photoIndex].media_url}`}
                            nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
                            prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
                            onCloseRequest={() => setIsOpen(false)}
                            onMovePrevRequest={() =>
                                setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
                            }
                            onMoveNextRequest={() =>
                                setPhotoIndex((photoIndex + 1) % lightboxImages.length)
                            }
                        />}
                    </div>
                    <div className=" border-bottom py-3 px-4">
                        <h6 className="fw-bold m-0">Users Activity Details</h6>
                    </div>
                    <div className="row p-4 gy-4">
                        <div className="col-12 col-lg-6 col-xl-7">
                            <div className="media-image">
                                <Carousel interval={null}>
                                    {state?.post_medias?.length ?
                                        state?.post_medias.map((res, index) => {
                                            // console.log("res", res);
                                            return (
                                                <Carousel.Item key={index}>
                                                    {(res?.media_type == "VIDEO" || res?.media_type == "VIDEO/MP4") ? (
                                                        <VideoPlayer src={res?.media_url} />) :
                                                        (
                                                            <img
                                                                className="rounded-lg h-[88vw] md:h-[40vw] w-100"
                                                                src={res.media_url ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${res?.media_url}` : ""}
                                                                alt="PostImage"
                                                                onClick={() => initialiseLightBox(state?.post_medias)}
                                                                style={{ cursor: "pointer" }} />
                                                        )
                                                    }
                                                </Carousel.Item>
                                            )
                                        }) : <img
                                            className="d-block w-100"
                                            src={placeholder}
                                            alt="PostImage"
                                            style={{ cursor: "pointer" }} />}
                                </Carousel>
                            </div>

                        </div>
                        <div className="col-12 col-lg-6 col-xl-5">
                            <div className="media-content px-3">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <div className="profile-section d-flex align-items-center gap-3">
                                            <div className="profile-image">
                                                {/* <img src={(profile_pic != "" && profile_pic != null) ? (social_type == "GOOGLE" || social_type == "FACEBOOK" || social_type == "APPLE" ? profile_pic :`${henceforthApi.API_FILE_ROOT_ORIGINAL}${profile_pic}`) : placeholder} alt="img" />
                                                 */}
                                                {/* <img
                                                    src={
                                                        profile_pic
                                                            ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${profile_pic}`
                                                            : placeholder
                                                    }
                                                    alt="img"
                                                /> */}
                                                <img
                                                    src={getUserProfileImage(profile_pic)}
                                                    className="me-2 imageSize"
                                                    alt="Profile"
                                                    onError={(e) => {
                                                        e.currentTarget.onerror = null;
                                                        e.currentTarget.src = placeholder;
                                                    }}
                                                />

                                            </div>
                                            <div>
                                                <h5 className="m-0">{state?.user_data?.full_name ? state?.user_data?.full_name : ""}</h5>
                                                <p className="m-0">{state?.data?.created_at ? moment(Number(state?.data?.created_at)).format("DD MMM YYYY ; hh:mm a") : ""}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="custom-active-btn">
                                        <button className={`btn ${state?.data?.post_status == "Active" ? `btn-outline-danger` : `btn-outline-success`}`} onClick={handleActivate}>{state?.data?.post_status == "Active" ? "Deactivate" : "Activate"}</button>
                                    </div>
                                </div>
                                <div className="py-3">
                                    <p>{state?.data?.caption ? state?.data?.caption : ""}</p>
                                </div>
                                <div className="row ">
                                    {/* <div className="col-12">
                                        <div className="d-flex justify-content-between border-bottom pb-2">
                                            {state?.data?.post_type == "STORY" ?
                                                <div className="media-icon d-flex align-items-start gap-1">
                                                    <span className="">{state?.views_count ? state?.views_count : 0}</span>
                                                    <img src={eye_light} alt="img" />
                                                </div> :
                                                <div className="media-icon d-flex align-items-start gap-1">
                                                    <span className="">{state?.like ? state?.like : 0}</span>
                                                    <img src={like} alt="img" />
                                                </div>}
                                            <div className="media-icon d-flex align-items-center gap-3">
                                                <div className="d-flex align-items-start gap-1">
                                                    <span className="">{state?.comment ? state?.comment : 0}</span>
                                                    <img src={comment} alt="img" />
                                                </div>
                                                {state?.data?.post_type == "STORY" ? "" :
                                                    <div className="media-icon d-flex align-items-start gap-1">
                                                        <span className="">{state?.tag_count ? state?.tag_count : 0}</span>
                                                        <img src={tag} alt="img" />
                                                    </div>
                                                }
                                               
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="col-12">
                                        <div className="d-flex justify-content-between py-2 border-bottom flex-wrap gap-2 activity-section">
                                            {state?.data?.post_type == "STORY" ?
                                                <button className="bg-transparent border-0 media-icon d-flex align-items-center gap-1" onClick={() => handleNavigate("view")}>
                                                    {/* <img src={match.params.type == "view" ? eye_dark : eye_light} alt="img" /> */}
                                                    <span className={`${match.params.type == "view" ? `fw-bold` : ""}`}>{state?.views_count ? state?.views_count : 0}</span>
                                                    <p className={`${match.params.type == "view" ? `fw-bold` : ""} m-0`}>
                                                        View
                                                    </p>
                                                </button>
                                                :
                                                <button className="bg-transparent border-0 media-icon d-flex align-items-center gap-1" onClick={() => handleNavigate("like")}>
                                                     <span className={`${match.params.type == "like" ? `fw-bold` : ""}`}>{state?.like ? state?.like : 0}</span>
                                                    {/* <ThumbsUp
                                                        className={`w-6 h-6 p-1 rounded cursor-pointer transition-colors hover:text-white hover:fill-black
                                                                    ${match.params.type == "like"
                                                                ? "bg-white text-black "
                                                                : "bg-transparent text-gray-500 hover:bg-white  "}`}
                                                    /> */}
                                                    <p className={`${match.params.type == "like" ? `fw-bold` : ""} m-0`}>
                                                        Like
                                                    </p>
                                                </button>
                                            }
                                            {/* <button className="bg-transparent border-0 media-icon d-flex align-items-center gap-1" onClick={() => handleNavigate("like")}>
                                                <img src={match.params.type == "like" ? like_click : like2} alt="img" />
                                                <p className={`${match.params.type == "like" ? `fw-bold` : ""} m-0`}>
                                                    {state?.data?.post_type == "STORY" ? "View" : "Like"}
                                                </p>
                                            </button> */}
                                            <div className="media-icon d-flex align-items-center gap-1" onClick={() => handleNavigate("comment")}>
                                                {/* <MessageSquareText
                                                    className={`w-6 h-6 p-1 rounded cursor-pointer transition-colors hover:text-white hover:fill-black
                                                             ${match.params.type == "comment"
                                                            ? "bg-white text-black "
                                                            : "bg-transparent text-gray-500 hover:bg-white  "}`}
                                                /> */}
                                                <span className={`${match.params.type == "comment" ? `fw-bold` : ""}`}>{state?.comment ? state?.comment : 0}</span>
                                                <p className={`${match.params.type == "comment" ? `fw-bold` : ""} m-0`}>{state?.data?.post_type == "STORY" ? "Replies" : "Comments"}</p>
                                            </div>
                                            {state?.data?.post_type == "STORY" ? "" :
                                                <div className="media-icon d-flex align-items-center gap-1" onClick={() => handleNavigate("tags")}>
                                                    {/* <Tag
                                                        className={`w-6 h-6 p-1 rounded cursor-pointer transition-colors hover:text-white hover:fill-black
                                                                   ${match.params.type == "tags"
                                                                ? "bg-white text-black "
                                                                : "bg-transparent text-gray-500 hover:bg-white  "}`}
                                                    /> */}
                                                    <span className={`${match.params.type == "tags" ? `fw-bold` : ""}`}>{state?.tag_count ? state?.tag_count : 0}</span>
                                                    <p className={`${match.params.type == "tags" ? `fw-bold` : ""} m-0`}>Tags</p>
                                                </div>
                                            }
                                            {state?.data?.post_type == "STORY" ? "" :
                                                <div className="media-icon d-flex align-items-center gap-1" onClick={() => handleNavigate("coins")}>
                                                    {/* <img src={match.params.type == "coins" ? coin_click : dollar2} alt="img" />
                                                    <p className={`${match.params.type == "coins" ? `fw-bold` : ""} m-0`}>Coins</p> */}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {loading ? <div className="text-center mt-3"><Spinner /> </div> : <div className="col-12">
                                        <div className={getLike?.data?.length ? "activity-content" : getComment?.replies?.length ? "activity-content activity-height " : "activity-content"} >
                                            {/* comment-section */}
                                            {match.params.type == "comment" && state?.data?.post_type == "POST" ? <div className="row h-100 align-items-center">
                                                {/* <div className="col-12">
                                                    comment section
                                                </div> */}
                                                {!loading && getComment?.data?.length ? getComment?.data?.slice(0, readMore).map((item) =>
                                                    <div className="col-12">
                                                        <div className="comment-list d-flex align-items-start gap-3 py-2 border-bottom">
                                                            <div className="comment-list-img">
                                                                {/* <img src={(item.profile_pic != "" && item.profile_pic != null) ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.profile_pic}` : placeholder} alt="img" /> */}
                                                                <img
                                                                    src={getUserProfileImage(item.profile_pic)}
                                                                    className="me-2 imageSize"
                                                                    alt="Profile"
                                                                    onError={(e) => {
                                                                    e.currentTarget.onerror = null;
                                                                    e.currentTarget.src = placeholder;
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="comment-list-text">
                                                                <p className="m-0"><span className="fw-bold">{item?.name ? item?.name : "Not available"}</span> {item?.comments ? item?.comments : "Not available"}.</p>
                                                                <span>{item?.created_at ? moment(Number(item?.created_at)).format("hh:mm a") : ""}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : <div className="nodata-img">
                                                    <img src={nodata} alt="img" className="img-fluid" />
                                                    <div className="text-center">No Comments Available</div>
                                                </div>}
                                                {(getComment?.data?.length > 10 && getComment?.data?.length > readMore) ? <div className="col-12">
                                                    <div className="mt-2 text-end">
                                                        <button className="btn" onClick={() => setReadMore(readMore + 10)}>Load more</button>
                                                    </div>
                                                </div> : ""}
                                            </div> : ""}

                                             {match.params.type == "comment" && state?.data?.post_type == "STORY" ? <div className="row h-100 align-items-center">
                                                {/* <div className="col-12">
                                                    comment section
                                                </div> */}
                                                {!loading && getComment?.replies?.length ? getComment?.replies?.slice(0, readMore).map((item) =>
                                                    <div className="col-12">
                                                        <div className="comment-list d-flex align-items-start gap-3 py-2 border-bottom">
                                                            <div className="comment-list-img">
                                                                {/* <img src={(item.profile_pic != "" && item.profile_pic != null) ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.profile_pic}` : placeholder} alt="img" /> */}
                                                                <img
                                                                    src={getUserProfileImage(item.profile_pic)}
                                                                    className="me-2 imageSize"
                                                                    alt="Profile"
                                                                    onError={(e) => {
                                                                    e.currentTarget.onerror = null;
                                                                    e.currentTarget.src = placeholder;
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="comment-list-text">
                                                                <p className="m-0"><span className="fw-bold">{item?.full_name ? item?.full_name : "Not available"}</span> {item?.message ? item?.message : "Not available"}.</p>
                                                                <span>{item?.created_at ? moment(Number(item?.created_at)).format("hh:mm a") : ""}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : <div className="nodata-img">
                                                    <img src={nodata} alt="img" className="img-fluid" />
                                                    <div className="text-center">No Comments Available</div>
                                                </div>}
                                                {(getComment?.replies?.length > 10 && getComment?.replies?.length > readMore) ? <div className="col-12">
                                                    <div className="mt-2 text-end">
                                                        <button className="btn" onClick={() => setReadMore(readMore + 10)}>Load more</button>
                                                    </div>
                                                </div> : ""}
                                            </div> : ""}

                                            {/* like section */}
                                            {match.params.type == "like" ? <>
                                                {!loading && getLike?.data?.length ? getLike?.data?.slice(0, readMore)?.map((item) => <div className="row h-100 align-items-center">
                                                    <div className="col-12">
                                                        <div className="comment-list d-flex align-items-center gap-3 py-2 border-bottom">
                                                            <div className="comment-list-img">
                                                                <img src={getUserProfileImage(item?.profile_pic)} alt="img" />
                                                            </div>
                                                            <div className="comment-list-text">
                                                                <p className="m-0"><span className="fw-bold">{item?.name ? item?.name : "Not available"}</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                ) : <div className="nodata-img">
                                                    <img src={nodata} alt="img" className="img-fluid" />
                                                    <div className="text-center">No Likes Available</div>
                                                </div>
                                                }

                                                {(getLike?.data?.length > 10 && getLike?.data?.length > readMore) ? <div className="col-12">
                                                    <div className="mt-2 text-end">
                                                        <button className="btn" onClick={() => setReadMore(readMore + 10)}>Load more</button>
                                                    </div>
                                                </div> : ""}
                                            </> : ""}

                                            {/* View Section  */}

                                            {match.params.type == "view" ? <>
                                                {getView?.views?.length ? getView?.views?.slice(0, readMore)?.map((item) => {
                                                    console.log(item, "items");
                                                    return (
                                                        <div className="row h-100 align-items-center">
                                                            <div className="col-12">
                                                                <div className="comment-list d-flex align-items-center gap-3 py-2 border-bottom">
                                                                    <div className="comment-list-img">
                                                                        <img src={getUserProfileImage(item?.profile_pic)} alt="img" />
                                                                    </div>
                                                                    <div className="comment-list-text">
                                                                        <p className="m-0"><span className="fw-bold">{item?.full_name ? item?.full_name : "Not available"}</span></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }) : <div className="nodata-img">
                                                    <img src={nodata} alt="img" className="img-fluid" />
                                                    <div className="text-center">No Likes Available</div>
                                                </div>
                                                }
                                                {(getLike?.data?.length > 10 && getLike?.data?.length > readMore) ? <div className="col-12">
                                                    <div className="mt-2 text-end">
                                                        <button className="btn" onClick={() => setReadMore(readMore + 10)}>Load more</button>
                                                    </div>
                                                </div> : ""}
                                            </> : ""}

                                            {/* tag section */}
                                            {match.params.type == "tags" ? <div className="row  h-100 align-items-center">
                                                {!loading && getTags?.tagged_users?.length ? getTags?.tagged_users?.slice(0, readMore)?.map((item) => <div className="col-12">
                                                    <div className="comment-list d-flex align-items-center gap-3 py-2 border-bottom">
                                                        <div className="comment-list-img">
                                                            <img src={getUserProfileImage(item?.profile_pic)} alt="img" />
                                                        </div>
                                                        <div className="comment-list-text">
                                                            <p className="m-0"><span className="fw-bold">{item?.full_name ? item?.full_name : "Not available"}</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                ) : <div className="nodata-img">
                                                    <img src={nodata} alt="img" className="img-fluid" />
                                                    <div className="text-center">No Tags Available</div>
                                                </div>}
                                                {(getTags?.tagged_users?.length > 10 && getTags?.tagged_users?.length > readMore) ? <div className="col-12">
                                                    <div className="mt-2 text-end">

                                                        <button className="btn" onClick={() => setReadMore(readMore + 10)}>Load more</button>
                                                    </div>
                                                </div> : ""}
                                            </div> : ""}

                                            {/* dollar section */}
                                            {match.params.type == "coins" ? <div className="row gy-3 h-100 align-items-center">
                                                {/* <div className="col-12">
                                                    dollar section
                                                </div> */}
                                                {!loading && getCoins?.data?.length ? getCoins?.data?.slice(0, readMore)?.map((item) => <div className="col-12">
                                                    <div className="comment-list custom-border d-flex align-items-center gap-3  p-2">
                                                        <div className="comment-list-img">
                                                            <img src={getUserProfileImage(item?.users?.profile_pic)} alt="img" />
                                                        </div>
                                                        <div className="comment-list-text w-100">
                                                            <div className="d-flex justify-content-between align-items-center dollar-text">
                                                                {/* <div className="">
                                                                    <h6 className="m-0 mb-2">{item?.users?.full_name ? item?.users?.full_name : ""}</h6>
                                                                    <p className="m-0">John Howard</p>
                                                                </div> */}
                                                                <div className="">
                                                                    <div className="d-flex align-items-center justify-content-end gap-1 mb-2">
                                                                        <span className="fw-bold">{item?.users.full_name ? item?.users.full_name : "Not available"}</span>
                                                                        <img src={dollarlogo} alt="img" />

                                                                        <h6 className="m-0">{item?.coins ? item?.coins : 0}</h6>
                                                                    </div>
                                                                    <p className="m-0">{item?.users?.created_at ? moment(Number(item?.users?.created_at)).format("hh:mm a") : ""}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                ) : <div className="nodata-img">
                                                    <img src={nodata} alt="img" className="img-fluid" />
                                                    <div className="text-center">No Coins Available</div>
                                                </div>}
                                                {(getCoins?.data?.length > 10 && getCoins?.data?.length > readMore) ? <div className="col-12">
                                                    <div className="mt-2 text-end">
                                                        <button className="btn" onClick={() => setReadMore(readMore + 10)}>Load more</button>
                                                    </div>
                                                </div> : ""}
                                            </div> : ""}
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default MediaDetails;